export const PRODUCT_TYPE_DEALING = 1;
export const PRODUCT_TYPE_ISA = 3;
export const PRODUCT_TYPE_SIPP = 2;
export const PRODUCT_TYPE_JISA = 4;
export const PRODUCT_TYPE_JSIPP = 5;
export const PRODUCT_TYPE_LISA = 8;
export const PRODUCT_TYPE_MEMO_ASSETS = 9;
export const PRODUCT_TYPE_RAISIN = 10;

export const sortOrder = [
    PRODUCT_TYPE_SIPP,
    PRODUCT_TYPE_JSIPP,
    PRODUCT_TYPE_ISA,
    PRODUCT_TYPE_JISA,
    PRODUCT_TYPE_LISA,
    PRODUCT_TYPE_DEALING,
    PRODUCT_TYPE_RAISIN,
    PRODUCT_TYPE_MEMO_ASSETS
];

export const PRODUCT_TYPE_DESCRIPTIONS = {
    1: 'Dealing account',
    3: 'Stocks and shares ISA',
    2: 'SIPP',
    4: 'JISA',
    5: 'Junior SIPP',
    8: 'Lifetime ISA',
    9: 'Mywealth'
};

export default class Accounts {

    constructor() {
        this.accounts = [];
    }

    getButtonOutlineColorByProduct(productType) {
        switch(productType) {
            case PRODUCT_TYPE_ISA:
                return 'button--outline-orange';
            case PRODUCT_TYPE_JISA:
            case PRODUCT_TYPE_JSIPP:
                return 'button--outline-purple';
            case PRODUCT_TYPE_LISA:
                return 'button--outline-darkblue';
            case PRODUCT_TYPE_SIPP:
                return 'button--outline-green';
            case PRODUCT_TYPE_DEALING:
                return 'button--outline-lightblue';
            case PRODUCT_TYPE_MEMO_ASSETS:
                return 'button--outline-grey';
            case PRODUCT_TYPE_RAISIN:
                return 'button--outline-red';
        }
    }
    
    setAccounts(accounts) {
        this.accounts = accounts;
    }

    getAccountsSorted() {
        let accountsSorted = {};

        this.accounts.forEach((account) => {
            let accountNumber;
            
            if (account.productType === PRODUCT_TYPE_MEMO_ASSETS) {
                accountNumber = account.number.substring(0, account.number.length - 2);
            } else {
                accountNumber = account.number.substring(0, account.number.length - 1);
            }
            
            if (!accountsSorted.hasOwnProperty(accountNumber)) {
                accountsSorted[accountNumber] = [];
            }
            
            accountsSorted[accountNumber].push(account);
        });
        
        return accountsSorted;
    }

} 